(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gcc-contact-card"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gcc-contact-card-v1')) {
  customElements.define('gcc-contact-card-v1', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        const link = this.querySelector('[data-auto-vcard]');
        if (!link) return;
        const d = this.dataset;
        const slash = String.fromCharCode(92);
        const esc = value => [...(value || '').replace(/\r\n|\r/g, String.fromCharCode(10))].map(char => {
          if (char === slash || char === ';' || char === ',') return slash + char;
          return char.charCodeAt(0) === 10 ? slash + 'n' : char;
        }).join('');
        const lines = ['BEGIN:VCARD', 'VERSION:3.0',
          'N:' + esc(d.lastName) + ';' + esc(d.firstName || d.fullName) + ';;;',
          'FN:' + esc(d.fullName), 'ORG:' + esc(d.company), 'TITLE:' + esc(d.role),
          'TEL;TYPE=CELL:' + esc(d.phone), 'EMAIL;TYPE=INTERNET:' + esc(d.email),
          'ADR;TYPE=WORK:;;' + esc(d.address) + ';;;;', 'URL:' + esc(d.website), 'END:VCARD'];
        // Fold lines at 75 UTF-8 bytes without splitting Unicode characters.
        const encoder = new TextEncoder();
        const fold = line => {
          let result = '', bytes = 0;
          for (const char of line) {
            const length = encoder.encode(char).length;
            if (bytes + length > 75) { result += '\r\n '; bytes = 1; }
            result += char; bytes += length;
          }
          return result;
        };
        if (this.vcardUrl) URL.revokeObjectURL(this.vcardUrl);
        this.vcardUrl = URL.createObjectURL(new Blob([lines.map(fold).join('\r\n') + '\r\n'], {type:'text/vcard;charset=utf-8'}));
        link.href = this.vcardUrl;
        link.download = (d.fullName || 'contact').replace(/[^\p{L}\p{N}_-]+/gu, '_') + '.vcf';
        link.hidden = false;
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.vcardUrl) URL.revokeObjectURL(this.vcardUrl);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
